module.exports = __webpack_public_path__ + "static/media/2 Don't Think Twice, It's All Right.10cce85c.mp3";